import { useToast, POSITION } from "vue-toastification";

export default function (message: any, options?: object)
{
	const toast = useToast();
	return toast.info(message, {
		position: POSITION.TOP_RIGHT,
		timeout: 8000,
		...options
	});
}
